import { render, staticRenderFns } from "./AddEditQuiz.vue?vue&type=template&id=9c9e8144"
import script from "./AddEditQuiz.vue?vue&type=script&lang=js"
export * from "./AddEditQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports